module.exports = __webpack_public_path__ + "static/media/wooden_desktop.8bf93d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/wooden_desktop.png
// module id = 170
// module chunks = 0